import { render, staticRenderFns } from "./japanPlanGift.vue?vue&type=template&id=f7a41670&scoped=true&"
import script from "./japanPlanGift.vue?vue&type=script&lang=js&"
export * from "./japanPlanGift.vue?vue&type=script&lang=js&"
import style0 from "./japanPlanGift.vue?vue&type=style&index=0&id=f7a41670&scoped=true&lang=css&"
import style1 from "./japanPlanGift.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7a41670",
  null
  
)

export default component.exports